<template>
<div>
    <v-dialog
        v-model="display"
        width="1150"
        scrollable
        persistent>
        <CustomerDisplayDialogSkeleton v-if="loading.data" />
        <v-card v-else>
            <v-toolbar
                flat
                >
                <v-toolbar-title>{{customer ? customer.name : ''}} - {{customer ? customer.code: ''}}</v-toolbar-title>
                <v-spacer></v-spacer>
                <v-menu v-if="!loading.data" offset-y>
                    <template v-slot:activator="{on}">
                        <v-btn
                            icon
                            v-on="on"
                            class="mx-1">
                            <v-icon>mdi-dots-vertical</v-icon>
                        </v-btn>
                    </template>
                    <v-list width="250" dense>

                        <v-list-item
                            v-if="authorizations.customers.update"
                            @click="openCustomerDialog({editMode: true, id: customer.id })"
                            link>
                            <v-list-item-icon>
                                <v-icon>mdi-pencil</v-icon>
                            </v-list-item-icon>
                            <v-list-item-title>{{ $t('edit_customer') }}</v-list-item-title>
                        </v-list-item>

                        <v-list-item
                            v-if="authorizations.customers.delete"
                            @click="openDeleteDialog({target: 'customerDisplayDialog', items: [customer]})"
                            link>
                            <v-list-item-icon>
                                <v-icon>mdi-delete</v-icon>
                            </v-list-item-icon>
                            <v-list-item-title>{{ $t('delete_customer') }}</v-list-item-title>
                        </v-list-item>

                        <v-divider class="my-2"></v-divider>

                        <v-list-item link @click="openSalesOrderDialog({ editMode: false, customer: customer.name, customer_id: customer.id })">
                            <v-list-item-icon>
                                <v-icon>mdi-circle</v-icon>
                            </v-list-item-icon>
                            <v-list-item-title>{{ $t("new_sales_order") }}</v-list-item-title>
                        </v-list-item>

                        <v-list-item link @click="openInvoiceDialog">
                            <v-list-item-icon>
                                <v-icon>mdi-circle</v-icon>
                            </v-list-item-icon>
                            <v-list-item-title>{{ $t("new_invoice") }}</v-list-item-title>
                        </v-list-item>
                        <!--
                            -->
                        <v-divider class="my-2"></v-divider>

                        <v-list-item
                            :disabled="!authorizations.sites.create"
                            @click="openCustomerSiteDialog({ editMode: false, id: customer.id })"
                            link>
                            <v-list-item-icon>
                                <v-icon :disabled="!authorizations.sites.create">mdi-database-plus</v-icon>
                            </v-list-item-icon>
                            <v-list-item-title>{{ $t('new_site') }}</v-list-item-title>
                        </v-list-item>

                        <v-list-item
                            @click="openCustomerSiteDialog({ editMode: true, id: selected.site[0].id })"
                            v-if="selected.site.length == 1 && authorizations.sites.update"
                            link>
                            <v-list-item-icon>
                                <v-icon>mdi-pencil</v-icon>
                            </v-list-item-icon>
                            <v-list-item-title>{{ $t('edit_site') }}</v-list-item-title>
                        </v-list-item>

                        <v-list-item
                            v-if="selected.site.length && authorizations.sites.delete"
                            @click="openDeleteDialog({target: 'customerSiteDialog', items: selected.site})"
                            link>
                            <v-list-item-icon>
                                <v-icon>mdi-delete</v-icon>
                            </v-list-item-icon>
                            <v-list-item-title>{{ $t('delete_site') }}</v-list-item-title>
                        </v-list-item>

                        <v-divider class="my-2"></v-divider>

                        <v-list-item @click="openStatementPrintDialog" link>
                            <v-list-item-icon>
                                <v-icon>mdi-printer</v-icon>
                            </v-list-item-icon>
                            <v-list-item-title>{{ $t('print_customer_statement') }}</v-list-item-title>
                        </v-list-item>

                        <v-divider v-if="!haveAccount" class="my-2"></v-divider>

                        <v-list-item
                            @click="openCustomerAccountProps"
                            v-if="!haveAccount"
                            link>
                            <v-list-item-icon>
                                <v-icon>mdi-book-account-outline</v-icon>
                            </v-list-item-icon>
                            <v-list-item-title>{{ $t('new_customer_account') }}</v-list-item-title>
                        </v-list-item>

                        <v-list-item link v-if="selected.account.length">
                            <v-list-item-icon>
                                <v-icon>mdi-pencil</v-icon>
                            </v-list-item-icon>
                            <v-list-item-title>{{ $t('edit_account_assignment') }}</v-list-item-title>
                        </v-list-item>

                        <!-- <v-list-item
                                v-if="selected.account.length"
                                link>
                                <v-list-item-icon>
                                    <v-icon>mdi-delete</v-icon>
                                </v-list-item-icon>
                                <v-list-item-title>{{ $t('delete_account_assignment') }}</v-list-item-title>
                            </v-list-item>  -->
                    </v-list>
                </v-menu>
                <template v-slot:extension>
                    <v-tabs v-model="tab" center-active show-arrows="">
                        <v-tab>{{ $t("Dashboard") }}</v-tab>
                        <v-tab @click="fetchCustomerSalesOrders()">{{$t("blanket_agreements")}}</v-tab>
                        <v-tab v-if="hasPermission(permissions.sales_invoice.read)" @click="fetchCustomerInvoices()">{{ $t("invoices") }}</v-tab>
                        <v-tab v-if="hasPermission(permissions.report.customer_statement)" @click="fetchTheCustomerStatement">{{ $t("statement") }}</v-tab>
                        <v-tab>{{ $t("sites") }}</v-tab>
                        <v-tab @click="getCustomerSentSms">Sent SMS</v-tab>
                        <v-tab v-if="hasPermission(permissions.customer_activities.read)" >{{ $t('customer_activity') }}</v-tab>
                        <v-tab v-if="hasPermission(permissions.sales_scheduling.read)">Scheduling</v-tab>
                    </v-tabs>
                </template>
            </v-toolbar>
            <v-card-text v-if="customer">
                <br>
                <v-tabs-items v-model="tab">
                    <!-- Dashboard -->
                    <v-tab-item>
                        <v-row>
                            <v-col cols="12" md="3">
                                <CustomerInfo
                                    :name="customer.name"
                                    :phones="customer.phones"
                                    :email="customer.email"
                                    :salesPerson="customer.sales_person"/>
                            </v-col>
                            <v-col cols="6" md="3">
                                <DashboardBox
                                    icon="mdi-cash"
                                    color="success"
                                    title="Payments"
                                    :value="millify(customer.payments_total)"
                                    outlined
                                    dark />
                            </v-col>
                            <v-col cols="6" md="3">
                                <DashboardBox
                                    icon="mdi-receipt"
                                    color="success"
                                    title="Total Sales"
                                    :value="millify(customer.invoices_total)"
                                    outlined
                                    dark />
                            </v-col>
                            <v-col cols="6" md="3">
                                <DashboardBox
                                    icon="mdi-cash-register"
                                    :color="customer.account_balance < 0 ? 'success' : 'error'"
                                    title="Balance"
                                    :value="millify(customer.account_balance)"
                                    outlined
                                    dark />
                            </v-col>
                        </v-row>
                    </v-tab-item>
                    <!-- blanket agreements -->
                    <v-tab-item>
                        <SalesOrdersDataTable
                            :loading="loading.salesOrders"
                            :salesOrders="salesOrders"
                            :length="length.salesOrders"
                            @updated="fetchCustomerSalesOrders"
                            :pagination="false" />
                    </v-tab-item>
                    <!-- Invoices -->
                    <v-tab-item v-if="hasPermission(permissions.sales_invoice.read)">
                        <InvoicesDataTable
                            :data="invoices"
                            :loading="loading.invoices"
                            :length="length.invoices"
                            @updated="fetchCustomerInvoices"
                            :pagination="false" />
                    </v-tab-item>
                    <!-- statement -->
                    <v-tab-item v-if="hasPermission(permissions.report.customer_statement)">
                        <CustomerStatementTable :statement="statement" :loading="loading.statement" />
                    </v-tab-item>
                    <!-- sites -->
                    <v-tab-item>
                        <v-data-table
                            dense
                            hide-default-footer
                            disable-pagination
                            show-select
                            single-select
                            v-model="selected.site"
                            :items="sites"
                            :headers="headers.site">
                        </v-data-table>
                    </v-tab-item>
                    <!-- SMS Tab -->
                    <v-tab-item>
                        <CustomerSentSmsDatatable v-bind="customerSentSms" />
                    </v-tab-item>
                    <!-- Activity-->
                    <v-tab-item  v-if="hasPermission(permissions.customer_activities.read)">
                        <customer-activity :customer="customer"></customer-activity>
                    </v-tab-item>
                     <!-- Scheduling-->
                    <v-tab-item v-if="hasPermission(permissions.sales_scheduling.read)">
                        <CustomerSalesSchedulingList :customer-id="customer.id"/>
                    </v-tab-item>
                </v-tabs-items>
            </v-card-text>
            <v-card-actions>
                <v-btn text @click="close">
                    {{ $t("close_btn") }}
                </v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
    <RetryDialog ref="retryDialog" @submit="onRetryDialogSubmit" />
    <CustomerDialog @submit="openDataFetch" ref="customerDialog" />
    <CustomerSiteDialog ref="customerSiteDialog" />
    <DeleteDialog ref="deleteDialog" @submit="onDeleteDialogSubmit" />
    <AlertDialog ref="alertDialog" />
    <StatementPrintDialog ref="statementPrintDialog" />
    <SalesOrderDialog ref="salesOrderDialog" @submit="fetchCustomerSalesOrders" />
    <InvoiceDialog
        v-if="invoiceDialog.display"
        :display="invoiceDialog.display"
        :data="invoiceDialog.data"
        @submit="fetchCustomerInvoices"
        @close="closeInvoiceDialog" />
    <LoadingDialog :display="loadingDialog.display" :message="loadingDialog.message" />
    <DecisionDialog ref="decisionDialog" @submit="decisionDialogHandler" />
    <customer-assign-dialog
        v-if="customerAssignProps.display"
        :id="customerAssignProps.id"
        :customerName="customerAssignProps.customer_name"
        :customerId="customerAssignProps.customer_id"
        @submit="getCustomerAccount"
        @close="closeCustomerAccountProps">
    </customer-assign-dialog>
</div>
</template>

<script>
import {
    findIndex,
    isEmpty
} from 'lodash';
import moment from 'moment';
import {
    formatMoney,
    formatNumber
} from 'accounting';
import {
    mapState,
    mapActions
} from 'vuex';

import {
    getCustomerReceivableAccount
} from '../../services/sales/customer';

import RetryDialog from '@/components/common/RetryDialog';
import CustomerDialog from '@/components/Sales/CustomerDialog';
import DeleteDialog from '@/components/common/DeleteDialog';
import AlertDialog from '@/components/common/AlertDialog';
import CustomerSiteDialog from '@/components/Sales/CustomerSiteDialog';
import CustomerStatementTable from '../../components/Sales/CustomerStatementTable';
import StatementPrintDialog from '../../components/Sales/StatementPrintDialog';
import CustomerDisplayDialogSkeleton from '../../components/Sales/CustomerDisplayDialogSkeleton';
import SalesOrdersDataTable from '../Sales/SalesOrdersDataTable';
import InvoicesDataTable from '../Sales/InvoicesDataTable';
import SalesOrderDialog from '../Sales/SalesOrderDialog';
import InvoiceDialog from '../Sales/InvoiceDialog';
import LoadingDialog from '../common/LoadingDialog';
import DecisionDialog from '../common/DecisionDialog';
import CustomerSentSmsDatatable from '../Sales/CustomerSentSmsDatatable';
import CustomerAssignDialog from './CustomerAssignDialog.vue';
import CustomerInfo from '../Sales/CustomerInfo';
import DashboardBox from '../common/DashboardBox';
import CustomerActivity from './CustomerActivity.vue';
import CustomerSalesSchedulingList from './CustomerSalesSchedulingList'
import authorize from '../../utils/authorize';
import permissions from '../../data/permissions';
import millify from 'millify'

export default {
    name: "CustomerDisplayDialog",
    components: {
        RetryDialog,
        CustomerDialog,
        CustomerSiteDialog,
        DeleteDialog,
        AlertDialog,
        CustomerStatementTable,
        StatementPrintDialog,
        CustomerDisplayDialogSkeleton,
        SalesOrdersDataTable,
        InvoicesDataTable,
        SalesOrderDialog,
        InvoiceDialog,
        LoadingDialog,
        DecisionDialog,
        CustomerSentSmsDatatable,
        CustomerAssignDialog,
        CustomerInfo,
        DashboardBox,
        CustomerActivity,
        CustomerSalesSchedulingList
    },
    data() {
        return {
            tab: 0,
            currency: "SDG",
            display: false,
            openParams: {},
            loading: {
                data: false,
                statement: false,
                salesOrdersLines: false,
                invoicesLines: false,
                salesOrders: false,
                invoices: false,
            },
            loadingDialog: {
                display: false,
                message: ""
            },
            length: {
                salesOrders: 0,
                invoices: 0
            },
            headers: {
                site: [{
                        text: this.$t('name'),
                        value: 'name'
                    },
                    {
                        text: this.$t('adderss'),
                        value: 'address'
                    }
                ]
            },
            selected: {
                site: [],
                account: []
            },
            statementSearchParams: {
                from: moment().subtract(1, 'year').format("YYYY-MM-DD"),
                to: new moment().format("YYYY-MM-DD"),
                customer_id: null,
            },
            statement: {},
            customerAccount: null,
            salesOrdersLines: [],
            invoicesLines: [],
            salesOrders: [],
            invoices: [],
            invoiceDialog: {
                display: false,
                data: {},
            },
            customerSentSms: {
                loading: false,
                messages: []
            },
            customerAssignProps: {
                id: null,
                customer_id: null,
                customer_name: null,
                display: false
            },
            permissions
        }
    },
    computed: {
        ...mapState('sales/customer', ["customer"]),
        ...mapState("sales/site", ["sites"]),
        ...mapState('authentication', ["authorizations"]),
        accountId() {
            return this.selected.account.length == 1 ? this.selected.account[0].id : null;
        },
        haveAccount() {
            return !isEmpty(this.customerAccount);
        }
        // customerAccount() {
        //     // return

        // }
    },
    methods: {
        formatNumber,
        millify,
        ...mapActions("sales/customer", ["fetchCustomer", "removeCustomers", "fetchCustomerStatement", "fetchCustomerSalesOrdersLines", "fetchCustomerInvoicesLines"]),
        ...mapActions("sales/salesOrder", ["fetchSalesOrders"]),
        ...mapActions("sales/invoice", ["fetchInvoices"]),
        ...mapActions("sales/site", ["fetchSites", "removeSites"]),
        ...mapActions("sms", ["notifyCodeBySms", "getCustomersSentSms"]),
        formatCurrency(amount) {
            return formatMoney(amount, "SDG ", 2);
        },
        hasPermission(permission) {
            return authorize(permission);
        },
        open(params) {
            this.openParams = params;
            this.loading.data = true;
            this.openDataFetch();
            this.display = true;
        },
        async openDataFetch() {
            try {
                await Promise.all([this.fetchCustomer(this.openParams.id), this.fetchSites({
                    customer_id: this.openParams.id
                })]);
                this.getCustomerAccount();
                this.loading.data = false;
                this.setInvoiceDialogData();
            } catch (error) {
                this.close();
                let message = error.response ? error.response.data.message : error;
                this.$refs.retryDialog.open({
                    target: "openDataFetch",
                    message
                });
            }
        },
        onRetryDialogSubmit(params) {
            if (params.target == "openDataFetch") {
                if (params.retry) this.openDataFetch();
            }
        },
        onDeleteDialogSubmit(params) {
            if (params.target == "customerSiteDialog") {
                this.removeSites({
                        itemsIds: params.itemsIds
                    })
                    .then(() => {
                        this.$refs.deleteDialog.close();
                        this.fetchSites({
                            customer_id: this.openParams.id
                        });
                        this.$refs.alertDialog.open({
                            type: "success",
                            message: this.$t("records_delete_success")
                        });
                    })
                    .catch(error => {
                        this.$refs.deleteDialog.close();
                        let message = error.response ? error.response.data.message : error;
                        this.$refs.alertDialog.open({
                            type: "error",
                            message
                        });
                    })

            } else if (params.target == "customerDisplayDialog") {
                this.removeCustomers({
                        itemsIds: params.itemsIds
                    })
                    .then(() => {
                        this.$refs.deleteDialog.close();
                        this.close();
                        this.$refs.alertDialog.open({
                            type: "success",
                            message: this.$t("records_delete_success")
                        });
                    })
                    .catch(error => {
                        this.$refs.deleteDialog.close();
                        let message = error.response ? error.response.data.message : error;
                        this.$refs.alertDialog.open({
                            type: "error",
                            message
                        });
                    })
            }
        },
        openCustomerSiteDialog(params) {
            this.$refs.customerSiteDialog.open(params);
            this.selected.site = [];
        },
        openCustomerDialog(params) {
            this.$refs.customerDialog.open(params);
        },
        openDeleteDialog(params) {
            this.$refs.deleteDialog.open(params);
        },
        openCustomerAccountProps() {
            this.customerAssignProps.id = null;
            this.customerAssignProps.customer_id = this.openParams.id;
            this.customerAssignProps.customer_name = this.openParams.name;
            this.customerAssignProps.display = true;
        },
        closeCustomerAccountProps() {
            this.customerAssignProps.display = false;
        },
        getCustomerAccount() {
            // service(`sales/customers/${this.openParams.id}/accounts`, 'get')
            getCustomerReceivableAccount({
                    customerId: this.openParams.id
                })
                .then((response) => {
                    this.customerAccount = response.data;
                    console.log('response', response);
                })
                .catch((error) => {
                    console.log('error', error);
                })
        },
        async fetchTheCustomerStatement() {
            try {
                this.loading.statement = true;
                this.statementSearchParams.customer_id = this.openParams.id;
                let response = await this.fetchCustomerStatement(this.statementSearchParams);
                this.statement = response.data;
                this.loading.statement = false;
            } catch (error) {
                let message = error.response ? error.response.data.message : error;
                this.$refs.alertDialog.open({
                    type: "error",
                    message
                });
            }
        },
        // async fetchTheCustomerSalesOrderLines()
        // {
        //     try {
        //         this.loading.salesOrdersLines = true;
        //         let response = await this.fetchCustomerSalesOrdersLines({customer_id: this.openParams.id});
        //         this.salesOrdersLines = response.data;
        //         this.loading.salesOrdersLines = false;
        //     } catch(error) {
        //         let message = error.response ? error.response.data.message : error;
        //         this.$refs.alertDialog.open({type: "error", message});
        //     }
        // },
        // async fetchTheCustomerInvoicesLines()
        // {
        //     try {
        //         this.loading.invoicesLines = true;
        //         let response = await this.fetchCustomerInvoicesLines({customer_id: this.openParams.id});
        //         this.invoicesLines = response.data;
        //         this.loading.invoicesLines = false;
        //     } catch(error) {
        //         let message = error.response ? error.response.data.message : error;
        //         this.$refs.alertDialog.open({type: "error", message});
        //     }
        // },
        openStatementPrintDialog() {
            this.statementSearchParams.customer_id = this.openParams.id;
            this.$refs.statementPrintDialog.open(this.statementSearchParams);
        },
        async fetchCustomerSalesOrders(options = {
            itemsPerPage: 10
        }) {
            this.loading.salesOrders = true;
            options.customer_id = this.openParams.id;
            var result = await this.fetchSalesOrders(options);
            this.salesOrders = result.data.data;
            this.length.salesOrders = result.data.total;
            this.loading.salesOrders = false;
        },
        async fetchCustomerInvoices(options = {
            itemsPerPage: 10
        }) {
            this.loading.invoices = true;
            options.customer_id = this.openParams.id;
            var result = await this.fetchInvoices(options);
            this.invoices = result.data.data;
            this.length.invoices = result.data.total;
            this.loading.invoices = false;
        },
        openSalesOrderDialog(params) {
            this.$refs.salesOrderDialog.open(params);
        },
        openInvoiceDialog() {
            this.invoiceDialog.display = true;
        },
        closeInvoiceDialog() {
            this.invoiceDialog.display = false;
        },
        setInvoiceDialogData() {
            this.invoiceDialog.data.customer_id = this.customer.id;
            this.invoiceDialog.data.customer = this.customer.name;
        },
        openLoadingDialog(message) {
            this.loadingDialog.message = message;
            this.loadingDialog.display = true;
        },
        closeLoadingDialog() {
            this.loadingDialog.display = false;
            this.loadingDialog.message = "";
        },
        sendCodeBySmsDecision() {
            this.$refs.decisionDialog.open({
                target: "sendCodeBySms",
                title: this.$t("are_you_sure"),
                content: this.$t("send_sms_confirmation")
            });
        },
        decisionDialogHandler(params) {
            switch (params.target) {
                case "sendCodeBySms":
                    this.sendCodeBySms();
            }
        },
        async sendCodeBySms() {
            this.openLoadingDialog("Sending SMS ....");
            var response = await this.notifyCodeBySms({
                id: this.customer.id
            });
            // console.log(response);
            var status = response.status;
            var payload = status == 200 ? {
                type: "success",
                message: this.$t("message_sent_success")
            } : {
                type: "error",
                message: this.$t("message_sent_error")
            };

            this.$refs.alertDialog.open(payload);
            this.closeLoadingDialog();
        },
        phoneIsCall(phoneClass) {
            return findIndex(phoneClass, o => o == 1) === -1 ? false : true;
        },
        phoneIsSms(phoneClass) {
            return findIndex(phoneClass, o => o == 2) === -1 ? false : true;
        },
        async getCustomerSentSms() {
            this.customerSentSms.loading = true;
            var response = await this.getCustomersSentSms(this.customer.id);
            this.customerSentSms.loading = false;
            this.customerSentSms.messages = response.data;
        },
        close() {
            this.$emit("close");
            Object.assign(this.$data, this.$options.data.apply(this));
        }
    }
}
</script>
